<template>
    <div id="app" class="app fond">
         <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>

        <div class="fond-page">
            <section class="corps-texte">
                <section class="en-tete-page">
                    <h1>{{Page.page}}</h1>
                    <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                    
                </section>
                <section>
                    <section class="sectionFiltres ordi">
                        <div class="filtres">  
                            <div >
                                <svg @click="openFiltres = ! openFiltres" class="ButtonOuvertureFiltre" xmlns="http://www.w3.org/2000/svg" width="33" height="30" viewBox="0 0 33 30">
                                    <path id="Icon_feather-filter" data-name="Icon feather-filter" d="M33,4.5H3L15,18.69V28.5l6,3V18.69Z" transform="translate(-1.5 -3)" fill="none" stroke="#0F2D93" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                                </svg>
                            </div>
                            <div class="text-align: center">
                                <h3 v-show="openAlbums">Voici tous les albums</h3>
                                <h3 v-show="openImages" v-if="AlbumSelected == 0">Voici toutes les photos</h3>
                                <h3 v-show="openImages" v-if="AlbumSelected > 0">{{filterListImg[0].titre_album}}</h3>

                            </div>
                            <h4 v-show="openImages" v-if="AlbumSelected > 0">{{filterListImg[0].images.length}}/{{listeMedias.length}} photos</h4>
                            <h4 v-show="openImages" v-if="AlbumSelected == 0">{{listeMedias.length}} photos</h4>

                            <h4 v-show="openAlbums">{{listeAlbums.length}} albums</h4>
                            <h4 v-show="openVideos">{{listeVideos.length + 1}} vidéos</h4>
                        </div>
                        <div class="FiltresTris ordi" v-show="openFiltres">
                            <div class="menu-filtres" v-show="openAlbums">
                                <div class="input-recherche loupe">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="35.997" height="36.004" viewBox="0 0 35.997 36.004">
                                        <path id="Icon_awesome-search" data-name="Icon awesome-search" d="M35.508,31.127l-7.01-7.01a1.686,1.686,0,0,0-1.2-.492H26.156a14.618,14.618,0,1,0-2.531,2.531V27.3a1.686,1.686,0,0,0,.492,1.2l7.01,7.01a1.681,1.681,0,0,0,2.384,0l1.99-1.99a1.7,1.7,0,0,0,.007-2.391Zm-20.883-7.5a9,9,0,1,1,9-9A8.995,8.995,0,0,1,14.625,23.625Z" fill="#0F2D93"/>
                                    </svg>
                                    <input type="text" v-model="keyword" placeholder="Recherche par mots clé">                                      
                                </div>
                            
                                <div class="input-recherche listeAlbums" >
                                    <h4>Nombre d'albums correspondant à la recherche : {{filterListAlbum.length}}</h4>
                                </div>

                                <div class="input-recherche datePubli">
                                    <i class="input-date">Début</i>
                                    <input type="date" v-model="dateMin">
                                    <i class="input-date">Fin</i>
                                    <input type="date" v-model="dateMax">
                                </div>
                            </div>
                            <div class="menu-classification" v-show="openAlbums">
                                <div class="menu-classification">
                                    <h4 class="h4gauche">Afficher par</h4>
                                </div>
                                
                                <div class="menu-classification">
                                    <h4 class="h4droite">Trier par</h4>
                                </div>
                            </div>
                            <div class="menu-classification" v-show="openAlbums">
                                <div class="menu-classification affichage boutons-affichage">
                                    <div class="button-classification buttonAlbums buttonactif" @click="toggle(), openAlbums = true, openImages = false, openVideos = false" id="buttonAlbums">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="33.757" height="29.116" viewBox="0 0 33.757 29.116" class="fill">
                                            <g id="Icon_ionic-ios-albums" data-name="Icon ionic-ios-albums"  transform="translate(-1.125 -3.445)">
                                            <path id="Tracé_9" data-name="Tracé 9" d="M32.407,11.32H3.593a2.476,2.476,0,0,0-2.468,2.468V30.094a2.476,2.476,0,0,0,2.468,2.468H32.414a2.476,2.476,0,0,0,2.468-2.468V13.788A2.486,2.486,0,0,0,32.407,11.32Z" />
                                            <path id="Tracé_10" data-name="Tracé 10" d="M30.516,9.352H5.484A.987.987,0,0,1,4.5,8.367h0a.987.987,0,0,1,.984-.984H30.516a.987.987,0,0,1,.984.984h0A.987.987,0,0,1,30.516,9.352Z" />
                                            <path id="Tracé_11" data-name="Tracé 11" d="M28.35,5.414H7.65a.906.906,0,0,1-.9-.9V4.345a.906.906,0,0,1,.9-.9h20.7a.906.906,0,0,1,.9.9v.169A.906.906,0,0,1,28.35,5.414Z"/>
                                            </g>
                                        </svg>
                                        <h4>Albums</h4>
                                    </div>
                                    
                                    <div class="button-classification buttonImages" @click="toggle(), openAlbums = false, openImages = true, openVideos = false" id="buttonImages">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" class="fill" viewBox="0 0 27 27">
                                            <path id="Icon_material-photo" data-name="Icon material-photo" d="M31.5,28.5V7.5a3.009,3.009,0,0,0-3-3H7.5a3.009,3.009,0,0,0-3,3v21a3.009,3.009,0,0,0,3,3h21A3.009,3.009,0,0,0,31.5,28.5ZM12.75,20.25l3.75,4.515L21.75,18l6.75,9H7.5Z" transform="translate(-4.5 -4.5)" />
                                        </svg>                                          
                                        <h4>Photos</h4>
                                    </div>

                                    <div class="button-classification buttonVideos" @click="toggle(), openAlbums = false, openImages = false, openVideos = true" id="buttonVideos">
                                        <svg xmlns="http://www.w3.org/2000/svg"  width="27" height="27" class="fill" viewBox="0 0 576 512">
                                            <path d="M384 112v288c0 26.51-21.49 48-48 48h-288c-26.51 0-48-21.49-48-48v-288c0-26.51 21.49-48 48-48h288C362.5 64 384 85.49 384 112zM576 127.5v256.9c0 25.5-29.17 40.39-50.39 25.79L416 334.7V177.3l109.6-75.56C546.9 87.13 576 102.1 576 127.5z"/>
                                        </svg>                                          
                                        <h4>Vidéos</h4>
                                    </div>
                                </div>
                                <div class="menu-classification">
                                    <div class="button-classification buttonReini ButtonOuvertureFiltre" @click="ReiniFiltres()" id="buttonReini">
                                        <h4 class="ButtonOuvertureFiltre">Réinitialiser les filtres</h4> 
                                    </div>
                                </div>
                                <div class="menu-classification Tri boutons-tris">
                                    <div class="input-recherche listeAlbums" id="buttonDateAlbums" @click="toggleTri()">
                                        <select v-model="OrderAlbum">
                                            <option value="DateCroissant">Du plus récent au plus ancien</option>
                                            <option value="DateDecroissant">Du plus ancien au plus récent</option>
                                            <option value="NomCroissant">De A à Z</option>
                                            <option value="NomDecroissant">De Z à A</option>
                                        </select>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="Blue-fill" width="36" height="36" viewBox="0 0 36 36">
                                            <path id="Icon_open-sort-descending" data-name="Icon open-sort-descending" d="M9,0V27H0l11.25,9L22.5,27h-9V0Zm9,0V4.5H36V0Zm0,9v4.5H31.5V9Zm0,9v4.5h9V18Z"/>
                                        </svg>
                                    </div>
                                    
                                </div>
                            </div>


                            <div class="menu-filtres" v-show="openImages">
                                <div class="input-recherche loupe">
                                     <svg xmlns="http://www.w3.org/2000/svg" width="33.757" height="29.116" viewBox="0 0 33.757 29.116">
                                        <g id="Icon_ionic-ios-albums" data-name="Icon ionic-ios-albums" transform="translate(-1.125 -3.445)">
                                        <path id="Tracé_9" data-name="Tracé 9" d="M32.407,11.32H3.593a2.476,2.476,0,0,0-2.468,2.468V30.094a2.476,2.476,0,0,0,2.468,2.468H32.414a2.476,2.476,0,0,0,2.468-2.468V13.788A2.486,2.486,0,0,0,32.407,11.32Z" fill="#0F2D93"/>
                                        <path id="Tracé_10" data-name="Tracé 10" d="M30.516,9.352H5.484A.987.987,0,0,1,4.5,8.367h0a.987.987,0,0,1,.984-.984H30.516a.987.987,0,0,1,.984.984h0A.987.987,0,0,1,30.516,9.352Z" fill="#0F2D93"/>
                                        <path id="Tracé_11" data-name="Tracé 11" d="M28.35,5.414H7.65a.906.906,0,0,1-.9-.9V4.345a.906.906,0,0,1,.9-.9h20.7a.906.906,0,0,1,.9.9v.169A.906.906,0,0,1,28.35,5.414Z" fill="#0F2D93"/>
                                        </g>
                                    </svg>
                                    
                                    <select name="albums" id="album-select" v-model="AlbumSelected">
                                        <option value="0">Tous les albums</option>
                                        <option :value="album.id" v-for="album in listeAlbums" :key="album.id">{{album.titre_album}}</option>
                                    </select>                               
                                </div>
                            
                                <div class="input-recherche listeAlbums">
                                    <h4 v-if="AlbumSelected > 0">Nombres de photos correspondant à la recherche : {{filterListImg[0].images.length}}</h4>
                                    <h4 v-if="AlbumSelected == 0">Nombre de photos correspondant à la recherche : {{filterListImg.length}}</h4>
                                </div>

                                <div class="input-recherche datePubli">
                                    
                                </div>
                            </div>
                            <div class="menu-classification" v-show="openImages">
                                <div class="menu-classification">
                                    <h4 class="h4gauche">Afficher par</h4>
                                </div>
                                
                                <div class="menu-classification">
                                    
                                </div>
                            </div>
                            <div class="menu-classification" v-show="openImages">
                                <div class="menu-classification affichage boutons-affichage">
                                    <div class="button-classification buttonAlbums" @click="toggle(), openAlbums = true, openImages = false, openVideos = false" id="buttonAlbums">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="33.757" height="29.116" viewBox="0 0 33.757 29.116" class="fill">
                                            <g id="Icon_ionic-ios-albums" data-name="Icon ionic-ios-albums"  transform="translate(-1.125 -3.445)">
                                            <path id="Tracé_9" data-name="Tracé 9" d="M32.407,11.32H3.593a2.476,2.476,0,0,0-2.468,2.468V30.094a2.476,2.476,0,0,0,2.468,2.468H32.414a2.476,2.476,0,0,0,2.468-2.468V13.788A2.486,2.486,0,0,0,32.407,11.32Z" />
                                            <path id="Tracé_10" data-name="Tracé 10" d="M30.516,9.352H5.484A.987.987,0,0,1,4.5,8.367h0a.987.987,0,0,1,.984-.984H30.516a.987.987,0,0,1,.984.984h0A.987.987,0,0,1,30.516,9.352Z" />
                                            <path id="Tracé_11" data-name="Tracé 11" d="M28.35,5.414H7.65a.906.906,0,0,1-.9-.9V4.345a.906.906,0,0,1,.9-.9h20.7a.906.906,0,0,1,.9.9v.169A.906.906,0,0,1,28.35,5.414Z"/>
                                            </g>
                                        </svg>
                                        <h4>Albums</h4>
                                    </div>
                                    
                                    <div class="button-classification buttonImages buttonactif" @click="toggle(), openAlbums = false, openImages = true, openVideos = false" id="buttonImages">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" class="fill" viewBox="0 0 27 27">
                                            <path id="Icon_material-photo" data-name="Icon material-photo" d="M31.5,28.5V7.5a3.009,3.009,0,0,0-3-3H7.5a3.009,3.009,0,0,0-3,3v21a3.009,3.009,0,0,0,3,3h21A3.009,3.009,0,0,0,31.5,28.5ZM12.75,20.25l3.75,4.515L21.75,18l6.75,9H7.5Z" transform="translate(-4.5 -4.5)" />
                                        </svg>                                          
                                        <h4>Photos</h4>
                                    </div>

                                    <div class="button-classification buttonVideos" @click="toggle(), openAlbums = false, openImages = false, openVideos = true" id="buttonVideos">
                                        <svg xmlns="http://www.w3.org/2000/svg"  width="27" height="27" class="fill" viewBox="0 0 576 512">
                                            <path d="M384 112v288c0 26.51-21.49 48-48 48h-288c-26.51 0-48-21.49-48-48v-288c0-26.51 21.49-48 48-48h288C362.5 64 384 85.49 384 112zM576 127.5v256.9c0 25.5-29.17 40.39-50.39 25.79L416 334.7V177.3l109.6-75.56C546.9 87.13 576 102.1 576 127.5z"/>
                                        </svg>                                          
                                        <h4>Vidéos</h4>
                                    </div>
                                </div>
                                <div class="menu-classification">
                                    <div class="button-classification buttonReini" @click="ReiniFiltresImg()" id="buttonReini">
                                        <h4>Réinitialiser les filtres</h4> 
                                    </div>
                                </div>
                                <div class="menu-classification Tri boutons-tris">
                                    <div class="input-recherche listeAlbums" id="buttonDateAlbums" @click="toggleTri()">
                                       
                                    </div>
                                </div>
                            </div>

                            <div class="menu-classification" v-show="openVideos">
                                <div class="menu-classification">
                                    <h4 class="h4gauche">Afficher par</h4>
                                </div>
                                
                                <div class="menu-classification">
                                    
                                </div>
                            </div>

                            <div class="menu-classification" v-show="openVideos">
                                <div class="menu-classification affichage boutons-affichage">
                                    <div class="button-classification buttonAlbums" @click="toggle(), openAlbums = true, openImages = false, openVideos = false" id="buttonAlbums">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="33.757" height="29.116" viewBox="0 0 33.757 29.116" class="fill">
                                            <g id="Icon_ionic-ios-albums" data-name="Icon ionic-ios-albums"  transform="translate(-1.125 -3.445)">
                                            <path id="Tracé_9" data-name="Tracé 9" d="M32.407,11.32H3.593a2.476,2.476,0,0,0-2.468,2.468V30.094a2.476,2.476,0,0,0,2.468,2.468H32.414a2.476,2.476,0,0,0,2.468-2.468V13.788A2.486,2.486,0,0,0,32.407,11.32Z" />
                                            <path id="Tracé_10" data-name="Tracé 10" d="M30.516,9.352H5.484A.987.987,0,0,1,4.5,8.367h0a.987.987,0,0,1,.984-.984H30.516a.987.987,0,0,1,.984.984h0A.987.987,0,0,1,30.516,9.352Z" />
                                            <path id="Tracé_11" data-name="Tracé 11" d="M28.35,5.414H7.65a.906.906,0,0,1-.9-.9V4.345a.906.906,0,0,1,.9-.9h20.7a.906.906,0,0,1,.9.9v.169A.906.906,0,0,1,28.35,5.414Z"/>
                                            </g>
                                        </svg>
                                        <h4>Albums</h4>
                                    </div>
                                    
                                    <div class="button-classification buttonImages " @click="toggle(), openAlbums = false, openImages = true, openVideos = false" id="buttonImages">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" class="fill" viewBox="0 0 27 27">
                                            <path id="Icon_material-photo" data-name="Icon material-photo" d="M31.5,28.5V7.5a3.009,3.009,0,0,0-3-3H7.5a3.009,3.009,0,0,0-3,3v21a3.009,3.009,0,0,0,3,3h21A3.009,3.009,0,0,0,31.5,28.5ZM12.75,20.25l3.75,4.515L21.75,18l6.75,9H7.5Z" transform="translate(-4.5 -4.5)" />
                                        </svg>                                          
                                        <h4>Photos</h4>
                                    </div>

                                    <div class="button-classification buttonVideos buttonactif" @click="toggle(), openAlbums = false, openImages = false, openVideos = true" id="buttonVideos">
                                        <svg xmlns="http://www.w3.org/2000/svg"  width="27" height="27" class="fill" viewBox="0 0 576 512">
                                            <path d="M384 112v288c0 26.51-21.49 48-48 48h-288c-26.51 0-48-21.49-48-48v-288c0-26.51 21.49-48 48-48h288C362.5 64 384 85.49 384 112zM576 127.5v256.9c0 25.5-29.17 40.39-50.39 25.79L416 334.7V177.3l109.6-75.56C546.9 87.13 576 102.1 576 127.5z"/>
                                        </svg>                                          
                                        <h4>Vidéos</h4>
                                    </div>
                                </div>
                                <div class="menu-classification">

                                </div>
                                <div class="menu-classification Tri boutons-tris">
                                    <div class="input-recherche listeAlbums" id="buttonDateAlbums">
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>


                    <section class="sectionFiltres tablette">
                        <div class="filtres">  
                            <div>
                                <svg @click="openFiltresTablette = ! openFiltresTablette" class="ButtonOuvertureFiltre" xmlns="http://www.w3.org/2000/svg" width="33" height="30" viewBox="0 0 33 30">
                                    <path id="Icon_feather-filter" data-name="Icon feather-filter" d="M33,4.5H3L15,18.69V28.5l6,3V18.69Z" transform="translate(-1.5 -3)" fill="none" stroke="#0F2D93" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                                </svg>
                            </div>
                            <h4 v-show="openImages" v-if="AlbumSelected > 0">{{filterListImg[0].images.length}}/{{listeMedias.length}} photos</h4>
                            <h4 v-show="openImages" v-if="AlbumSelected == 0">{{listeMedias.length}} photos</h4>

                            <h4 v-show="openAlbums">{{listeAlbums.length}} albums</h4>
                            <h4 v-show="openVideos">{{listeVideos.length + 1}} vidéos</h4>
                        </div>

                        <div class="text-align: center">
                                <h3 v-show="openAlbums">Voici tous les albums</h3>
                                <h3 v-show="openImages" v-if="AlbumSelected == 0">Voici toutes les photos</h3>
                                <h3 v-show="openImages" v-if="AlbumSelected > 0">{{filterListImg[0].titre_album}}</h3>
                                <h3 v-show="openVideos">Voici toutes les vidéos</h3>
                            </div>
                        <div class="FiltresTris tablette" v-show="openFiltresTablette">
                            <svg @click="openFiltresTablette = false" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus" class="color-objet-fill croix-fermeture croix-fermeture-Img svg-inline--fa fa-plus fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                <path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path>
                            </svg>
                            <div class="menu-filtres" v-show="openAlbums">
                                <div class="input-recherche loupe">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="35.997" height="36.004" viewBox="0 0 35.997 36.004">
                                        <path id="Icon_awesome-search" data-name="Icon awesome-search" d="M35.508,31.127l-7.01-7.01a1.686,1.686,0,0,0-1.2-.492H26.156a14.618,14.618,0,1,0-2.531,2.531V27.3a1.686,1.686,0,0,0,.492,1.2l7.01,7.01a1.681,1.681,0,0,0,2.384,0l1.99-1.99a1.7,1.7,0,0,0,.007-2.391Zm-20.883-7.5a9,9,0,1,1,9-9A8.995,8.995,0,0,1,14.625,23.625Z" fill="#0F2D93"/>
                                    </svg>
                                    <input type="text" v-model="keyword" placeholder="Recherche par mots clé">                                      
                                </div>
                            
                                <div class="input-recherche input-recherche-texte listeAlbums" >
                                    <h4>Nombre d'albums correspondant à la recherche : {{filterListAlbum.length}}</h4>
                                </div>

                                <div class="input-recherche datePubli">
                                    <i class="input-date">Début</i>
                                    <input type="date" v-model="dateMin">
                                    <i class="input-date">Fin</i>
                                    <input type="date" v-model="dateMax">
                                </div>
                            </div>
                            <div class="menu-classification" v-show="openAlbums">
                                <div class="menu-classification">
                                    <h4 class="h4gauche">Afficher par</h4>
                                </div>
                                <div class="menu-classification affichage boutons-affichage">
                                    <div class="button-classification buttonAlbums buttonactif" @click="toggle(), openFiltresTablette = false, openAlbums = true, openImages = false, openVideos = false" id="buttonAlbums">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="33.757" height="29.116" viewBox="0 0 33.757 29.116" class="fill">
                                            <g id="Icon_ionic-ios-albums" data-name="Icon ionic-ios-albums"  transform="translate(-1.125 -3.445)">
                                            <path id="Tracé_9" data-name="Tracé 9" d="M32.407,11.32H3.593a2.476,2.476,0,0,0-2.468,2.468V30.094a2.476,2.476,0,0,0,2.468,2.468H32.414a2.476,2.476,0,0,0,2.468-2.468V13.788A2.486,2.486,0,0,0,32.407,11.32Z" />
                                            <path id="Tracé_10" data-name="Tracé 10" d="M30.516,9.352H5.484A.987.987,0,0,1,4.5,8.367h0a.987.987,0,0,1,.984-.984H30.516a.987.987,0,0,1,.984.984h0A.987.987,0,0,1,30.516,9.352Z" />
                                            <path id="Tracé_11" data-name="Tracé 11" d="M28.35,5.414H7.65a.906.906,0,0,1-.9-.9V4.345a.906.906,0,0,1,.9-.9h20.7a.906.906,0,0,1,.9.9v.169A.906.906,0,0,1,28.35,5.414Z"/>
                                            </g>
                                        </svg>
                                        <h4>Albums</h4>
                                    </div>
                                    
                                    <div class="button-classification buttonImages " @click="toggle(), openFiltresTablette = false, openAlbums = false, openImages = true, openVideos = false" id="buttonImages">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" class="fill" viewBox="0 0 27 27">
                                            <path id="Icon_material-photo" data-name="Icon material-photo" d="M31.5,28.5V7.5a3.009,3.009,0,0,0-3-3H7.5a3.009,3.009,0,0,0-3,3v21a3.009,3.009,0,0,0,3,3h21A3.009,3.009,0,0,0,31.5,28.5ZM12.75,20.25l3.75,4.515L21.75,18l6.75,9H7.5Z" transform="translate(-4.5 -4.5)" />
                                        </svg>                                          
                                        <h4>Photos</h4>
                                    </div>

                                    <div class="button-classification buttonVideos" @click="toggle(), openFiltresTablette = false, openAlbums = false, openImages = false, openVideos = true" id="buttonVideos">
                                        <svg xmlns="http://www.w3.org/2000/svg"  width="27" height="27" class="fill" viewBox="0 0 576 512">
                                            <path d="M384 112v288c0 26.51-21.49 48-48 48h-288c-26.51 0-48-21.49-48-48v-288c0-26.51 21.49-48 48-48h288C362.5 64 384 85.49 384 112zM576 127.5v256.9c0 25.5-29.17 40.39-50.39 25.79L416 334.7V177.3l109.6-75.56C546.9 87.13 576 102.1 576 127.5z"/>
                                        </svg>                                          
                                        <h4>Vidéos</h4>
                                    </div>
                                </div>
                                
                                <div class="menu-classification">
                                    <h4 class="h4droite">Trier par</h4>
                                </div>

                                 <div class="menu-classification Tri boutons-tris">
                                    <div class="input-recherche listeAlbums" id="buttonDateAlbums" @click="toggleTri()">
                                        <select v-model="OrderAlbum">
                                            <option value="DateCroissant">Du plus récent au plus ancien</option>
                                            <option value="DateDecroissant">Du plus ancien au plus récent</option>
                                            <option value="NomCroissant">De A à Z</option>
                                            <option value="NomDecroissant">De Z à A</option>
                                        </select>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="Blue-fill" width="36" height="36" viewBox="0 0 36 36">
                                            <path id="Icon_open-sort-descending" data-name="Icon open-sort-descending" d="M9,0V27H0l11.25,9L22.5,27h-9V0Zm9,0V4.5H36V0Zm0,9v4.5H31.5V9Zm0,9v4.5h9V18Z"/>
                                        </svg>
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="menu-classification" v-show="openAlbums">
                                
                                <div class="menu-classification">
                                    <div class="button-classification buttonReini ButtonOuvertureFiltre" @click="ReiniFiltres()" id="buttonReini">
                                        <h4 class="ButtonOuvertureFiltre">Réinitialiser les filtres</h4> 
                                    </div>
                                </div>
                               
                            </div>


                            <div class="menu-filtres" v-show="openImages">
                                <div class="input-recherche loupe">
                                     <svg xmlns="http://www.w3.org/2000/svg" width="33.757" height="29.116" viewBox="0 0 33.757 29.116">
                                        <g id="Icon_ionic-ios-albums" data-name="Icon ionic-ios-albums" transform="translate(-1.125 -3.445)">
                                        <path id="Tracé_9" data-name="Tracé 9" d="M32.407,11.32H3.593a2.476,2.476,0,0,0-2.468,2.468V30.094a2.476,2.476,0,0,0,2.468,2.468H32.414a2.476,2.476,0,0,0,2.468-2.468V13.788A2.486,2.486,0,0,0,32.407,11.32Z" fill="#0F2D93"/>
                                        <path id="Tracé_10" data-name="Tracé 10" d="M30.516,9.352H5.484A.987.987,0,0,1,4.5,8.367h0a.987.987,0,0,1,.984-.984H30.516a.987.987,0,0,1,.984.984h0A.987.987,0,0,1,30.516,9.352Z" fill="#0F2D93"/>
                                        <path id="Tracé_11" data-name="Tracé 11" d="M28.35,5.414H7.65a.906.906,0,0,1-.9-.9V4.345a.906.906,0,0,1,.9-.9h20.7a.906.906,0,0,1,.9.9v.169A.906.906,0,0,1,28.35,5.414Z" fill="#0F2D93"/>
                                        </g>
                                    </svg>
                                    
                                    <select name="albums" id="album-select" v-model="AlbumSelected">
                                        <option value="0">Tous les albums</option>
                                        <option :value="album.id" v-for="album in listeAlbums" :key="album.id">{{album.titre_album}}</option>
                                    </select>                               
                                </div>
                            
                                <div class="input-recherche input-recherche-texte listeAlbums">
                                    <h4 v-if="AlbumSelected > 0">Nombres de photos correspondant à la recherche : {{filterListImg[0].images.length}}</h4>
                                    <h4 v-if="AlbumSelected == 0">Nombre de photos correspondant à la recherche : {{filterListImg.length}}</h4>
                                </div>

                            </div>
                            <div class="menu-classification" v-show="openImages">
                                <div class="menu-classification">
                                    <h4 class="h4gauche">Afficher par</h4>
                                </div>

                                 <div class="menu-classification affichage boutons-affichage">
                                    <div class="button-classification buttonAlbums" @click="toggle(), openFiltresTablette = false, openAlbums = true, openImages = false, openVideos = false" id="buttonAlbums">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="33.757" height="29.116" viewBox="0 0 33.757 29.116" class="fill">
                                            <g id="Icon_ionic-ios-albums" data-name="Icon ionic-ios-albums"  transform="translate(-1.125 -3.445)">
                                            <path id="Tracé_9" data-name="Tracé 9" d="M32.407,11.32H3.593a2.476,2.476,0,0,0-2.468,2.468V30.094a2.476,2.476,0,0,0,2.468,2.468H32.414a2.476,2.476,0,0,0,2.468-2.468V13.788A2.486,2.486,0,0,0,32.407,11.32Z" />
                                            <path id="Tracé_10" data-name="Tracé 10" d="M30.516,9.352H5.484A.987.987,0,0,1,4.5,8.367h0a.987.987,0,0,1,.984-.984H30.516a.987.987,0,0,1,.984.984h0A.987.987,0,0,1,30.516,9.352Z" />
                                            <path id="Tracé_11" data-name="Tracé 11" d="M28.35,5.414H7.65a.906.906,0,0,1-.9-.9V4.345a.906.906,0,0,1,.9-.9h20.7a.906.906,0,0,1,.9.9v.169A.906.906,0,0,1,28.35,5.414Z"/>
                                            </g>
                                        </svg>
                                        <h4>Albums</h4>
                                    </div>
                                    
                                    <div class="button-classification buttonImages buttonactif" @click="toggle(), openFiltresTablette = false, openAlbums = false, openImages = true, openVideos = false" id="buttonImages">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" class="fill" viewBox="0 0 27 27">
                                            <path id="Icon_material-photo" data-name="Icon material-photo" d="M31.5,28.5V7.5a3.009,3.009,0,0,0-3-3H7.5a3.009,3.009,0,0,0-3,3v21a3.009,3.009,0,0,0,3,3h21A3.009,3.009,0,0,0,31.5,28.5ZM12.75,20.25l3.75,4.515L21.75,18l6.75,9H7.5Z" transform="translate(-4.5 -4.5)" />
                                        </svg>                                          
                                        <h4>Photos</h4>
                                    </div>

                                    <div class="button-classification buttonVideos " @click="toggle(), openFiltresTablette = false, openAlbums = false, openImages = false, openVideos = true" id="buttonVideos">
                                        <svg xmlns="http://www.w3.org/2000/svg"  width="27" height="27" class="fill" viewBox="0 0 576 512">
                                            <path d="M384 112v288c0 26.51-21.49 48-48 48h-288c-26.51 0-48-21.49-48-48v-288c0-26.51 21.49-48 48-48h288C362.5 64 384 85.49 384 112zM576 127.5v256.9c0 25.5-29.17 40.39-50.39 25.79L416 334.7V177.3l109.6-75.56C546.9 87.13 576 102.1 576 127.5z"/>
                                        </svg>                                          
                                        <h4>Vidéos</h4>
                                    </div>
                                </div>
    
                            </div>

                           

                            <div class="menu-classification" v-show="openVideos">

                                <div class="menu-classification affichage boutons-affichage">
                                    <div class="button-classification buttonAlbums" @click="toggle(), openFiltresTablette = false, openAlbums = true, openImages = false, openVideos = false" id="buttonAlbums">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="33.757" height="29.116" viewBox="0 0 33.757 29.116" class="fill">
                                            <g id="Icon_ionic-ios-albums" data-name="Icon ionic-ios-albums"  transform="translate(-1.125 -3.445)">
                                            <path id="Tracé_9" data-name="Tracé 9" d="M32.407,11.32H3.593a2.476,2.476,0,0,0-2.468,2.468V30.094a2.476,2.476,0,0,0,2.468,2.468H32.414a2.476,2.476,0,0,0,2.468-2.468V13.788A2.486,2.486,0,0,0,32.407,11.32Z" />
                                            <path id="Tracé_10" data-name="Tracé 10" d="M30.516,9.352H5.484A.987.987,0,0,1,4.5,8.367h0a.987.987,0,0,1,.984-.984H30.516a.987.987,0,0,1,.984.984h0A.987.987,0,0,1,30.516,9.352Z" />
                                            <path id="Tracé_11" data-name="Tracé 11" d="M28.35,5.414H7.65a.906.906,0,0,1-.9-.9V4.345a.906.906,0,0,1,.9-.9h20.7a.906.906,0,0,1,.9.9v.169A.906.906,0,0,1,28.35,5.414Z"/>
                                            </g>
                                        </svg>
                                        <h4>Albums</h4>
                                    </div>
                                    
                                    <div class="button-classification buttonImages " @click="toggle(), openFiltresTablette = false, openAlbums = false, openImages = true, openVideos = false" id="buttonImages">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" class="fill" viewBox="0 0 27 27">
                                            <path id="Icon_material-photo" data-name="Icon material-photo" d="M31.5,28.5V7.5a3.009,3.009,0,0,0-3-3H7.5a3.009,3.009,0,0,0-3,3v21a3.009,3.009,0,0,0,3,3h21A3.009,3.009,0,0,0,31.5,28.5ZM12.75,20.25l3.75,4.515L21.75,18l6.75,9H7.5Z" transform="translate(-4.5 -4.5)" />
                                        </svg>                                          
                                        <h4>Photos</h4>
                                    </div>

                                    <div class="button-classification buttonVideos buttonactif" @click="toggle(), openFiltresTablette = false, openAlbums = false, openImages = false, openVideos = true" id="buttonVideos">
                                        <svg xmlns="http://www.w3.org/2000/svg"  width="27" height="27" class="fill" viewBox="0 0 576 512">
                                            <path d="M384 112v288c0 26.51-21.49 48-48 48h-288c-26.51 0-48-21.49-48-48v-288c0-26.51 21.49-48 48-48h288C362.5 64 384 85.49 384 112zM576 127.5v256.9c0 25.5-29.17 40.39-50.39 25.79L416 334.7V177.3l109.6-75.56C546.9 87.13 576 102.1 576 127.5z"/>
                                        </svg>                                          
                                        <h4>Vidéos</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section class="liste-Albums">
                         <div class="pochette-Album" v-show="openAlbums" @click="toggleAlbum(album)">
                            <div class="derniereSlide">
                                <img src="static/css/img/logo/Quenne_C_FB.png" style="width: 100%;" alt="">
                            </div>
                            <div class="secondeSlide">
                                <img src="static/css/img/Pages/Accueil/Mairie-1.jpg" alt="ArretBusNangis">
                            </div>
                            
                            <div class="premiereSlide">
                                <img src="static/css/img/logo/Quenne_C_FB.png" style="width: 100%;" alt="">
                            </div>
                            <section class="Titre-Album">
                                <h5 class="AlbumTitre">Tous les albums</h5>
                            </section>
                        </div>
                        <div class="pochette-Album" v-for="album in filterListAlbum" :key="album.id" :id="album.id" v-show="openAlbums" @click="toggleAlbum(album)">
                            <div class="derniereSlide">
                                <img :src="album.images[2].url" alt="" v-if="album.images.length > 2">
                            </div>
                            <div class="secondeSlide">
                                <img :src="album.images[1].url" alt="" v-if="album.images.length > 1">
                            </div>
                            
                            <div class="premiereSlide">
                                <img :src="album.images[0].url" alt="">
                            </div>
                            <section class="Titre-Album">
                                <h5 class="AlbumTitre">{{album.titre_album}}</h5>
                            </section>
                        </div>
                        <div class="pochette-Album" v-if="filterListAlbum.length == 0" v-show="openAlbums">
                            <div class="derniereSlide">
                                <img src="static/css/img/FondSlideVide.jpg" alt="">
                            </div>
                            <div class="secondeSlide">
                                <img src="static/css/img/FondSlideVide.jpg" alt="">
                            </div>
                            
                            <div class="premiereSlide">
                               <img src="static/css/img/logo/Quenne_C_FB.png" style="width: 100%;" alt="test">
                            </div>
                            <section class="Titre-Album">
                                <h5 class="AlbumTitre">Aucun album ne correspond à votre recherche</h5>
                            </section>
                        </div>
                    </section>

                    <section id="photos" v-show="openImages" v-if="AlbumSelected == 0 || AlbumPubli == 0">
                        <div v-for="image in filterListImg" :key="image.id">
                            <div  @click="afficheImg(image)">
                                <img :src="image.url" alt="" class="pointer">
                            </div>
                        </div>
                    </section>

                    <section id="photos" v-show="openImages" v-if="AlbumSelected > 0 || AlbumPubli > 0">
                        <div v-for="image in filterListImg[0].images" :key="image.id">
                            <div @click="afficheImg(image)">
                                <img :src="image.url" alt="" class="pointer">
                            </div>
                        </div>
                    </section>

                    <section class="liste-Albums" v-show="openVideos">
                        <div v-for="video in listeVideos" :key="video.id">
                            <div v-if="video.type == 'Fichier vidéo'">
                                <video width="350" height="197" controls>
                                    <source :src="video.lien.url" type="video/mp4">
                                    Votre navigateur ne supporte pas ce type de format vidéo
                                </video>
                                <h6 style="margin-top: 5px; text-align:center">{{video.titre}}</h6>
                            </div>
                            <div v-if="video.type == 'Youtube'">
                                <iframe width="350" height="197" :src="video.lien" title="YouTube video player" style="border-radius: 25px" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                <h6>{{video.titre}}</h6>
                            </div>
                            
                        </div>
                        
                    </section>
                </section>
            </section>
        </div>
        <div class="ImageGrde" v-show="ImgGde">
            <img class="ImgGdeDiv" :src="imageCourante" alt="">

            <div class="divFermeture" @click="ImgGde = false"></div>

            <svg @click="ImgGde = false" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus" class="color-objet-fill croix-fermeture croix-fermeture-Img svg-inline--fa fa-plus fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path>
            </svg>

            <svg @click="InfoImage = true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="InfoImage">
                <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 128c17.67 0 32 14.33 32 32c0 17.67-14.33 32-32 32S224 177.7 224 160C224 142.3 238.3 128 256 128zM296 384h-80C202.8 384 192 373.3 192 360s10.75-24 24-24h16v-64H224c-13.25 0-24-10.75-24-24S210.8 224 224 224h32c13.25 0 24 10.75 24 24v88h16c13.25 0 24 10.75 24 24S309.3 384 296 384z"/>
            </svg>

            <div class="InfoImageDiv" @click="InfoImage = false" v-show="InfoImage" v-for="image in listeMedias" :key="image.id">
                <table v-if="image.url == imageCourante">
                    <tbody>
                        <tr>
                            <th>Copyright</th>
                            <th v-if="image.meta.image_meta.copyright != ''">{{image.meta.image_meta.copyright}}</th>
                            <th v-if="image.meta.image_meta.copyright == ''">Non référencé</th>
                        </tr>
                        <tr>
                            <th>Taille</th>
                            <th>{{image.meta.width}} * {{image.meta.height}}</th>
                        </tr>
                        <tr v-if="image.meta.image_meta.camera != ''">
                            <th>Appareil</th>
                            <th>{{image.meta.image_meta.camera}}</th>
                        </tr>
                    </tbody>
                </table>
            </div>

            <svg xmlns="http://www.w3.org/2000/svg" class="fill flecheImg fGauche" width="29.25" height="29.25" viewBox="0 0 29.25 29.25" @click="OuvertureImgPre(imageCourante)" v-if="AlbumSelected == 0">
                <path id="Icon_ionic-ios-arrow-dropleft-circle" data-name="Icon ionic-ios-arrow-dropleft-circle" d="M18,3.375A14.625,14.625,0,1,0,32.625,18,14.623,14.623,0,0,0,18,3.375ZM21.052,23.7a1.362,1.362,0,0,1,0,1.92,1.34,1.34,0,0,1-.956.394,1.364,1.364,0,0,1-.963-.4l-6.609-6.63a1.355,1.355,0,0,1,.042-1.87l6.708-6.729a1.357,1.357,0,1,1,1.92,1.92L15.434,18Z" transform="translate(-3.375 -3.375)"/>
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" class="fill flecheImg fGauche" width="29.25" height="29.25" viewBox="0 0 29.25 29.25" @click="OuvertureImgPreAlbum(imageCourante)" v-if="AlbumSelected > 0">
                <path id="Icon_ionic-ios-arrow-dropleft-circle" data-name="Icon ionic-ios-arrow-dropleft-circle" d="M18,3.375A14.625,14.625,0,1,0,32.625,18,14.623,14.623,0,0,0,18,3.375ZM21.052,23.7a1.362,1.362,0,0,1,0,1.92,1.34,1.34,0,0,1-.956.394,1.364,1.364,0,0,1-.963-.4l-6.609-6.63a1.355,1.355,0,0,1,.042-1.87l6.708-6.729a1.357,1.357,0,1,1,1.92,1.92L15.434,18Z" transform="translate(-3.375 -3.375)"/>
            </svg>
                        
            <svg xmlns="http://www.w3.org/2000/svg" class="fill flecheImg fDroite" width="29.25" height="29.25" viewBox="0 0 29.25 29.25" @click="OuvertureImgSui(imageCourante)" v-if="AlbumSelected == 0">
                <path id="Icon_ionic-ios-arrow-dropright-circle" data-name="Icon ionic-ios-arrow-dropright-circle" d="M3.375,18A14.625,14.625,0,1,0,18,3.375,14.623,14.623,0,0,0,3.375,18Zm17.191,0-5.759-5.7a1.357,1.357,0,0,1,1.92-1.92l6.708,6.729a1.356,1.356,0,0,1,.042,1.87l-6.609,6.63a1.355,1.355,0,1,1-1.92-1.912Z" transform="translate(-3.375 -3.375)"/>
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" class="fill flecheImg fDroite" width="29.25" height="29.25" viewBox="0 0 29.25 29.25" @click="OuvertureImgSuiAlbum(imageCourante)" v-if="AlbumSelected > 0">
                <path id="Icon_ionic-ios-arrow-dropright-circle" data-name="Icon ionic-ios-arrow-dropright-circle" d="M3.375,18A14.625,14.625,0,1,0,18,3.375,14.623,14.623,0,0,0,3.375,18Zm17.191,0-5.759-5.7a1.357,1.357,0,0,1,1.92-1.92l6.708,6.729a1.356,1.356,0,0,1,.042,1.87l-6.609,6.63a1.355,1.355,0,1,1-1.92-1.912Z" transform="translate(-3.375 -3.375)"/>
            </svg>

            <div class="ImgsPetitediv" v-if="AlbumSelected == 0">
                <div>
                    <div v-for="image in filterListImg" :key="image.id" @click="ImgGdeOuvert(image)">
                        <img :src="image.url" :alt="image.meta.image_meta.copyright">
                    </div>
                </div>
            </div>
            <div class="ImgsPetitediv" v-if="AlbumSelected > 0">
                <div>
                    <div v-for="image in filterListImg[0].images" :key="image.id" @click="ImgGdeOuvert(image)">
                        <img :src="image.url" alt="">
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>


import param from '@/param/param'

export default {
    name: 'EnImage',
    data () {
        return{
            ladate: null,
            date: null,
            openImages: false,
            openAlbums: true,
            openVideo: false,
            openFiltres: true,
            InfoImage: false,
            openFiltresTablette: false,
            fctAffichage: null,
            ImgGde: false,
            listeMedias:{
            },
            listeVideos:{
                id:0,
                type: null,
                lien: null
            },
            listeAlbums:{
                id:0,
            },
            album: 0,
            keyword:'',
            catSelected: 0,
            dateMin: '1839-08-19',
            dateMax : null,
            range: 0,
            OrderAlbum: 'DateCroissant',
            AlbumSelected: 0,
            CetAlbum: 0,
            imageCourante: 'https://mairie-quenne./wp-content/uploads/2022/04/Quenne_C_FT.png',
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            },
            IDImage: 0
        }

    }, 

    created(){
        var currentdate = new Date();
        var date = new Date;
        var annee = date.getFullYear();
        var moi = date.getMonth();
        var mois = new Array('Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre');
        var moisnumerique = new Array('01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12');

        var j = date.getDate();
        if(j < 10){
            j = '0'+j
        }
        var jour = date.getDay();
        var jours = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');
        this.date = jours[jour]+' '+j+' '+mois[moi]+' '+annee+'';
        this.time = currentdate.getHours()+" h "+currentdate.getMinutes()+" min "+currentdate.getSeconds()+" sec";
        this.joursemaine = jours[jour];
        this.datejour = +j+'/'+moi;
        this.dateJourNum = j+'/'+moisnumerique[moi]+'/'+annee;
        this.DateMaxEN = annee+'-'+moisnumerique[moi]+'-'+j
        this.jourInfini = mois[moi];

        this.dateMax = this.DateMaxEN;


        this.AlbumPubli = this.$route.params.id;
        

        if(this.AlbumPubli != 0){
            this.openImages = true,
            this.openAlbums = false,
            this.openVideos = false
        }else{
            this.openImages = false,
            this.openAlbums = true
            this.openVideos = false
        }

        axios.get(param.host+'album/v1/listeAlbums')
        .then(response =>{
            this.listeAlbums = response.data;
        })
        .catch(error => console.log(error))

        
        axios.get(param.host+'media/v1/listeMedias')
        .then(response =>{
            this.listeMedias = response.data;
        })
        .catch(error => console.log(error))

        axios.get(param.host+'video/v1/listeVideos')
        .then(response =>{
            this.listeVideos = response.data;
            
        })
        .catch(error => console.log(error))

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'En images'){
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))
    },

    computed:{
        filterListAlbum: function(){
            return this.filterAlbumByRange(this.filterAlbumByName(this.AlbumsOrderByName))
        },

        filterListImg : function(){
            return this.filterImageByAlbum(this.listeAlbums, this.listeMedias);
        },
        
        AlbumsOrderByName: function(){
            if(this.OrderAlbum == 'NomCroissant' && this.listeAlbums.length > 0){
                function compare(a, b){
                    if(a.slug < b.slug) return -1
                    if(a.slug > b.slug) return 1
                    return 0
                }
                return this.listeAlbums.sort(compare)
            }if(this.OrderAlbum =='NomDecroissant' && this.listeAlbums.length > 0){
                function compare(a, b){
                    if(a.slug > b.slug) return -1
                    if(a.slug < b.slug) return 1
                    return 0
                }
                return this.listeAlbums.sort(compare)
            }if(this.OrderAlbum == 'DateCroissant' && this.listeAlbums.length > 0){
                function compare(a, b){
                    if(a.date_de_debut > b.date_de_debut) return -1
                    if(a.date_de_debut < b.date_de_debut) return 1
                    return 0
                }
                return this.listeAlbums.sort(compare)
            }if(this.OrderAlbum == 'DateDecroissant ' && this.listeAlbums.length > 0){
                function compare(a, b){
                    if(a.date_de_debut < b.date_de_debut) return -1
                    if(a.date_de_debut > b.date_de_debut) return 1
                    return 0
                }
                return this.listeAlbums.sort(compare)
            }else{
                return this.listeAlbums
            }
        },
    },

    methods: {
        toggle: function() {
            this.AlbumSelected = 0,
            this.AlbumPubli = 0
        },

        toggleAlbum: function(album) {
            this.openAlbums = false,
            this.openImages = true,
            this.openVideos = false,
            this.AlbumSelected = 0,
            this.AlbumPubli = 0
            if(album != 0){
                this.AlbumSelected = album.id
            }else{
                this.AlbumSelected = 0
            }

            
        },

        afficheImg: function(img){

            this.imageCourante = img.url
            this.IDImage = img.id


            this.ImgGde = ! this.ImgGde
        },

        ImgGdeOuvert: function(img){
            this.imageCourante = img.url
            this.IDImage = img.id
        },

        OuvertureImgPre: function(img){
            let Images = new Array;
            var j = 0;
            for(var i = 0 ; this.filterListImg.length > i ; i++){
                Images[j] = this.filterListImg[i];
                if(img == Images[i].url){
                    let k = i - 1;
                    if(i == 0){
                        k = this.filterListImg.length - 1;
                    }
                    this.imageCourante = this.filterListImg[k].url
                }
                j++
            }

        },

        OuvertureImgSui: function(img){
            let Images = new Array()
            var j = 1;
            for(var i = 0 ; this.filterListImg.length > i ; i++){
                Images[j] = this.filterListImg[i];
                j++
            }

            Images[0] = Images[this.filterListImg.length - 1]

            for(var k = 0; Images.length > k ; k++){

                if(img == Images[k].url){
                    let l = k + 1;
                    if(l == Images.length){
                        l = 1
                    }
                    this.imageCourante = Images[l].url
                }
                
            }

        },

        OuvertureImgPreAlbum: function(img){
            let Images = new Array;
            var j = 0;

            for(var i = 0 ; this.filterListImg[0].images.length > i ; i++){
                Images[j] = this.filterListImg[0].images[i];
                if(img == Images[i].url){
                    let k = i - 1;
                    if(i == 0){
                        k = this.filterListImg[0].images.length - 1;
                    }
                    this.imageCourante = this.filterListImg[0].images[k].url
                }
                j++
            }

        },

        OuvertureImgSuiAlbum: function(img){
           let Images = new Array()
            var j = 1;
            for(var i = 0 ; this.filterListImg[0].images.length > i ; i++){
                Images[j] = this.filterListImg[0].images[i];
                j++
            }

            Images[0] = Images[this.filterListImg[0].images.length - 1]

            for(var k = 0; Images.length > k ; k++){

                if(img == Images[k].url){
                    let l = k + 1;
                    if(l == Images.length){
                        l = 1
                    }
                    this.imageCourante = Images[l].url
                }
                
            }
        },

        toggleTri: function() {
            let buttonDate = document.querySelector(".buttonDateAlbums");
            let buttonNom = document.querySelector(".buttonNomAlbums");

            buttonDate.classList.toggle("buttonactif");
            buttonNom.classList.toggle("buttonactif");
        },

        ReiniFiltres: function(){
            this.keyword = '';
            this.dateMin = '1839-08-19';
            this.dateMax = this.DateMaxEN;
            this.OrderAlbum = 'DateCroissant';
        },

        ReiniFiltresImg: function(){
            this.AlbumSelected = 0
        },

        filterAlbumByName: function(listeAlbums){
            return listeAlbums.filter(function(album){
                return (
                    album.titre_album.toLowerCase().indexOf(this.keyword.toLowerCase()) >= 0
                    ? album
                    : ''
                )
            }.bind(this))
        },

        filterAlbumByRange: function(listeAlbums){
            if(this.dateMin != '1839-08-19'|| this.dateMax != this.dateMaxEN){
                return listeAlbums.filter(album => (
                    album.date_de_debut >= this.dateMin && album.date_de_fin <= this.dateMax)
                    ? album
                    : ''
                )
            }else{
                return listeAlbums
            }
        },

        filterImageByAlbum: function(listeAlbums, listeMedias){
            let albums = listeAlbums;

            let CetAlbum = 0;

            
            if(this.AlbumPubli != 0){
                CetAlbum = this.AlbumPubli;
                this.AlbumSelected = this.AlbumPubli;
                this.AlbumPubli = 0
            }else{
                this.AlbumPubli == this.AlbumSelected;
                CetAlbum = this.AlbumSelected;
            }

            if(CetAlbum != 0){
                return albums.filter(function(album){
                    if(album.id == CetAlbum){
                        let imagesAlbum = album.images;
                        return imagesAlbum                        
                    }
                })
            }else{
                return listeMedias
            }
        }
    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/En-image.vue